export enum ExerciseType {
  LETTER_TO_NUMBER = "LETTER_TO_NUMBER",
  NUMBER_TO_LETTER = "NUMBER_TO_LETTER",
}
